module.exports = __webpack_public_path__ + "img/i_c_new_04.db88f766.svg";